// extracted by mini-css-extract-plugin
export var box = "_4k-2";
export var checkboxControl = "_4k-0";
export var checkboxRow = "_4k-a";
export var checked = "_4k-3";
export var descriptionSpacer = "_4k-c";
export var disabled = "_4k-4";
export var icon = "_4k-8";
export var input = "_4k-1";
export var labelSpacer = "_4k-b";
export var large = "_4k-7";
export var medium = "_4k-6";
export var small = "_4k-5";
export var text = "_4k-9";